import LoanApplicationEntity from './LoanApplicationEntity';
import LoanApplicationGateway from './LoanApplicationGateway';

export default class LoanApplicationService {
    static create(newLoan: LoanApplicationEntity) {
        return new LoanApplicationGateway().create(newLoan);
    }
}
